package com.shadowings.gero.data.lessons.chapter11

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.QuizText
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_l_infinito_1
import gero.composeapp.generated.resources.exp_content_l_infinito_2
import gero.composeapp.generated.resources.exp_content_l_infinito_3
import gero.composeapp.generated.resources.exp_content_l_infinito_4
import gero.composeapp.generated.resources.exp_content_l_infinito_5
import gero.composeapp.generated.resources.exp_content_l_infinito_6
import gero.composeapp.generated.resources.exp_content_l_infinito_7
import gero.composeapp.generated.resources.exp_content_l_infinito_8
import gero.composeapp.generated.resources.exp_content_l_infinito_9
import gero.composeapp.generated.resources.exp_content_l_infinito_10
import gero.composeapp.generated.resources.exp_content_l_infinito_11
import gero.composeapp.generated.resources.exp_content_l_infinito_12
import gero.composeapp.generated.resources.exp_content_l_infinito_13
import gero.composeapp.generated.resources.exp_content_l_infinito_14
import gero.composeapp.generated.resources.exp_title_l_infinito
import gero.composeapp.generated.resources.quiz_ripasso_cosa_significa_gero
import gero.composeapp.generated.resources.quiz_ripasso_traslitterazione

fun getLInfinitoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_1,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_2,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_3,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_4,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_6,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_8,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_9,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_10,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D4-A2",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_11,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D4:X1-A2",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_12,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_13,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_l_infinito,
            content = Res.string.exp_content_l_infinito_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

// Verbs taught by vocab lessons in chapters 5-7 (vocab_verbs_1..4, vocab_vso_1..2), i.e. already
// seen by the player at this point in the curriculum. verbs.tsv also has rows for APRIRE,
// GUARDARE, CANTARE, CHIAMARE, SIGILLARE, LAVORARE, SOLLEVARE, NAVIGARE, SPLENDERE, PURIFICARE
// and ARROSTIRE — those support lessons that aren't written yet, so every quiz in chapter 11 that
// draws from the full verb pool must filter through this whitelist until those lessons exist.
val KNOWN_VERB_KEYS_CHAPTER_11 = setOf(
    "MANGIARE", "DARE", "ASCOLTARE", "DIRE", "BERE", "USCIRE", "ENTRARE", "AMARE", "ESISTERE",
    "VOLARE", "COLTIVARE", "CACCIARE", "OFFRIRE", "VEDERE", "SCRIVERE", "PARLARE", "TROVARE",
    "FARE", "PORTARE", "CONOSCERE", "ANDARE", "INVIARE", "PRENDERE"
)

fun getLInfinitoQuizContent(
    verbs: List<Verb>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val validVerbPairs = verbs.filter { it.chiaveWords in KNOWN_VERB_KEYS_CHAPTER_11 }.mapNotNull { verb ->
        val word = words.firstOrNull { it.id == verb.chiaveWords }
        if (word != null) {
            val hieroInfinitive = verb.formaInfinita.ifBlank {
                if (verb.determinativo != "-") "${verb.formaBaseSenzaDet}-${verb.determinativo}" else verb.formaBaseSenzaDet
            }
            val transliteration = verb.traslitterazioneInfinita.ifBlank { verb.traslitterazione }
            Triple(verb, word, Pair(hieroInfinitive, transliteration))
        } else {
            null
        }
    }

    val shuffledPairs = validVerbPairs.shuffled()

    // SingleSelection quizzes (pick 7)
    val selectionQuizzes: List<IQuizContent> = shuffledPairs.take(7).map { (verb, word, inf) ->
        val otherWords = validVerbPairs.filter { it.first.chiaveWords != verb.chiaveWords }.map { it.second }
        val options = mutableListOf(Option(word.getMeaning(languageCode), correct = true))
        options.addAll(
            otherWords.shuffled().take(3).map { Option(it.getMeaning(languageCode), correct = false) }
        )

        SingleSelectionContent(
            text = Res.string.quiz_ripasso_cosa_significa_gero,
            detail = inf.first,
            options = options.shuffled(),
            info = QuizText.Resource(Res.string.quiz_ripasso_traslitterazione, listOf(inf.second))
        )
    }

    // TextTranslation quizzes (pick 3)
    val translationQuizzes: List<IQuizContent> = shuffledPairs.drop(7).take(3).map { (_, word, inf) ->
        TextTranslationContent(
            hieroglyphs = inf.first,
            correctPhrase = word.getMeaning(languageCode),
            transliteration = inf.second
        )
    }

    return (selectionQuizzes + translationQuizzes).shuffled()
}
